import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { NotFoundError, ConfigurationError } from '@cian/peperrors/shared';
import { State } from './internal';
export var Consumer = /*#__PURE__*/function () {
  /**
   * Топик, к которому подключен консьюмер
   *
   * @type {string}
   * @memberof Consumer
   */

  /**
   * Лог событий
   *
   * @type {IEventsLog}
   * @memberof Consumer
   */
  function Consumer(topic) {
    _classCallCheck(this, Consumer);

    _defineProperty(this, "topic", void 0);

    _defineProperty(this, "eventsLog", void 0);

    _defineProperty(this, "state", new State());

    _defineProperty(this, "offset", void 0);

    _defineProperty(this, "subscribers", new Set());

    _defineProperty(this, "maxSubscribers", 5);

    _defineProperty(this, "destroyTunnel", null);

    this.topic = topic;
    this.connect();
  }
  /**
   * Отключает консьюмер от лога событий
   *
   * @memberof Consumer
   */


  _createClass(Consumer, [{
    key: "destroy",
    value: function destroy() {
      // По какой-то причине istanbul счиатет, что строка не покрыта тестом

      /* istanbul ignore next */
      if (this.destroyTunnel) {
        this.destroyTunnel();
      }
    }
    /**
     * Добавляет подписчика в список
     *
     * @param {ISubscriber} subscriber - подписчик
     * @memberof Consumer
     */

  }, {
    key: "subscribe",
    value: function subscribe(subscriber) {
      if (this.subscribers.size === this.maxSubscribers) {
        throw new ConfigurationError({
          message: "Subscribers limit exceeded. They shouldn't be more than ".concat(this.maxSubscribers),
          domain: '@cian/events-log/Consumer#subscribe'
        });
      }

      this.subscribers.add(subscriber);
      this.readEventsLog();
    }
    /**
     * Отписать подписчика
     *
     * @param {ISubscriber} subscriber - подписчик
     * @memberof Consumer
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe(subscriber) {
      this.subscribers.delete(subscriber);
    }
    /**
     * Оповещает консьюмер о том, что в логе появились новые события
     *
     * @internal
     * @memberof Consumer
     */

  }, {
    key: "notify",
    value: function () {
      var _notify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.state.isWorking() || !this.subscribers.size)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return Promise.resolve();

              case 4:
                this.readEventsLog();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function notify() {
        return _notify.apply(this, arguments);
      }

      return notify;
    }()
    /**
     * Подключает консьюмер к логу событий
     *
     * @internal
     * @param {IEventsLog} eventsLog - лог событий
     * @memberof Consumer
     */

  }, {
    key: "tunnel",
    value: function tunnel(eventsLog) {
      this.eventsLog = eventsLog;
    }
  }, {
    key: "readEventsLog",
    value: function () {
      var _readEventsLog = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _iterator, _step, event, id, _iterator2, _step2, subscriber, promise;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.state.isWorking() || !this.eventsLog.size)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                this.state.setWorking();
                _iterator = _createForOfIteratorHelper(this.eventsLog.read(this.offset));
                _context2.prev = 4;

                _iterator.s();

              case 6:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 42;
                  break;
                }

                event = _step.value;

                if (event) {
                  _context2.next = 11;
                  break;
                }

                this.state.setPending();
                return _context2.abrupt("return");

              case 11:
                id = event.id;
                this.offset = id;
                _iterator2 = _createForOfIteratorHelper(this.subscribers);
                _context2.prev = 14;

                _iterator2.s();

              case 16:
                if ((_step2 = _iterator2.n()).done) {
                  _context2.next = 32;
                  break;
                }

                subscriber = _step2.value;

                if (!subscriber.closed) {
                  _context2.next = 20;
                  break;
                }

                return _context2.abrupt("continue", 30);

              case 20:
                _context2.prev = 20;
                promise = subscriber.next(event);

                if (!(promise instanceof Promise)) {
                  _context2.next = 25;
                  break;
                }

                _context2.next = 25;
                return promise;

              case 25:
                _context2.next = 30;
                break;

              case 27:
                _context2.prev = 27;
                _context2.t0 = _context2["catch"](20);
                subscriber.error(_context2.t0);

              case 30:
                _context2.next = 16;
                break;

              case 32:
                _context2.next = 37;
                break;

              case 34:
                _context2.prev = 34;
                _context2.t1 = _context2["catch"](14);

                _iterator2.e(_context2.t1);

              case 37:
                _context2.prev = 37;

                _iterator2.f();

                return _context2.finish(37);

              case 40:
                _context2.next = 6;
                break;

              case 42:
                _context2.next = 47;
                break;

              case 44:
                _context2.prev = 44;
                _context2.t2 = _context2["catch"](4);

                _iterator.e(_context2.t2);

              case 47:
                _context2.prev = 47;

                _iterator.f();

                return _context2.finish(47);

              case 50:
                this.subscribers.forEach(function (subscriber) {
                  return subscriber.complete();
                });
                this.state.setPending();

              case 52:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 44, 47, 50], [14, 34, 37, 40], [20, 27]]);
      }));

      function readEventsLog() {
        return _readEventsLog.apply(this, arguments);
      }

      return readEventsLog;
    }()
  }, {
    key: "connect",
    value: function connect() {
      if (!window.__cianGlobalEventsLogs) {
        throw new NotFoundError({
          message: 'Global events logs must be initialized, before connecting the consumer',
          domain: '@cian/events-log/consumer'
        });
      }

      this.destroyTunnel = window.__cianGlobalEventsLogs.consume(this.topic, this);
    }
  }]);

  return Consumer;
}();